export default __webpack_public_path__ + "static/media/cloud-star-bg.84873c83.svg";